import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { UniQActions } from "us.common/constants";
import { uniQActions } from "us.common/actions/UniQ";
import { UniQService } from "us.common/services";
import { UniQChatMessage } from "us.common/interfaces";
import { $MessageBox } from "us.common/components";

const uniQSaga = {
  sendMessage: function* (action: any): Generator<any, void, any> {
    const params = action.payload?.data;
    try {
      const { data } = yield call(UniQService.command.send, {
        CommandText: params.responseContent,
      });
      const response: UniQChatMessage = {
        id: data.id || new Date().toISOString(),
        responseType: data.responseType,
        responseContent: data.responseContent,
        links: data.links || [],
        timestamp: data.timestamp || new Date(),
        isUser: data.isUser || false,
        isError: data.isError || false,
        attachments: data.attachments || [],
      };
      yield put(uniQActions.message.success(response));
    } catch (error) {
      yield put(uniQActions.message.fail(error as any));
    }
  },
  getDefaultPrompt: function* (action: any): Generator<any, void, any> {
    const params = action.payload?.data;
    try {
      const { data, status } = yield call(UniQService.getDefaultPrompt, params);

      if (status === 200 && data) {
        yield put(uniQActions.defaultPromptData.success(data));
      } else {
        yield put(uniQActions.defaultPromptData.fail(new Error()));
      }
    } catch (error) {
      yield put(uniQActions.defaultPromptData.fail(error as any));
    }
  },
  saveDefaultPrompt: function* (action: any): Generator<any, void, any> {
    const params = action.payload?.data;
    try {
      const { status } = yield call(UniQService.saveDefaultPrompt, params);

      if (status === 200) {
        yield put(uniQActions.defaultPrompt.success(params));
        $MessageBox(
          "success",
          `US.COMMON:MESSAGES.PROMPT_UPDATED_SUCCESSFULLY`,
          "",
          "",
        );
      } else {
        $MessageBox("error", `US.COMMON:MESSAGES.PROMPT_UPDATE_FAILED`, "", "");
        yield put(uniQActions.defaultPrompt.fail(new Error()));
      }
    } catch (error) {
      $MessageBox("error", `US.COMMON:MESSAGES.PROMPT_UPDATE_FAILED`, "", "");
      yield put(uniQActions.defaultPrompt.fail(error as any));
    }
  },
  resetSession: function* (): Generator<any, void, any> {
    try {
      const { data, status } = yield call(UniQService.command.reset);
      if (status === 200) {
        $MessageBox(
          "success",
          "US.COMMON:UNIQ.SESSION_RESET_SUCCESS_MESSAGE", // UniQ session has been reset successfully.
          "",
          "",
        );
        yield put(uniQActions.session.success(data));
      } else {
        $MessageBox(
          "error",
          "US.COMMON:UNIQ.SESSION_RESET_FAIL_MESSAGE", // Failed to reset UniQ session.
          "",
          "",
        );
        yield put(uniQActions.session.fail({ data, status } as any));
      }
    } catch (error) {
      $MessageBox("error", "US.COMMON:UNIQ.SESSION_RESET_FAIL_MESSAGE", "", "");
      yield put(uniQActions.session.fail(error as any));
    }
  },
};

export default [
  takeLeading(UniQActions.SEND_MESSAGE, uniQSaga.sendMessage),
  takeLatest(UniQActions.GET_DEFAULT_PROMPT, uniQSaga.getDefaultPrompt),
  takeLeading(UniQActions.SAVE_DEFAULT_PROMPT, uniQSaga.saveDefaultPrompt),
  takeLeading(UniQActions.RESET_SESSION, uniQSaga.resetSession),
];
